import { ECloudRole, ICloudUser } from "../types"

export const getEffectiveUserRole = (user: ICloudUser): ECloudRole => {
  if (user.Roles === null) {
    return ECloudRole.Unknown
  }
  let roleNames = user.Roles.map((role) => role.Name)
  if (roleNames.includes(ECloudRole.SuperAdmin)) {
    return ECloudRole.SuperAdmin
  }
  if (roleNames.includes(ECloudRole.Admin)) {
    return ECloudRole.Admin
  }
  if (roleNames.includes(ECloudRole.User)) {
    return ECloudRole.User
  }
  return ECloudRole.Unknown
}

export const normalizeString = (str: string | undefined): string => {
  if (str === undefined) {
    return ""
  }
  return str
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // remove diacritics
}
